import { render, staticRenderFns } from "./add-sale-royalty-free-popup.vue?vue&type=template&id=4e6c4731"
import script from "./add-sale-royalty-free-popup.vue?vue&type=script&lang=js"
export * from "./add-sale-royalty-free-popup.vue?vue&type=script&lang=js"
import style0 from "./add-sale-royalty-free-popup.vue?vue&type=style&index=0&id=4e6c4731&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports